export const encodeToBase64 = (str: string): string => {
  const utf8Bytes: Uint8Array = new TextEncoder().encode(str);
  const binaryString = String.fromCharCode(...Array.from(utf8Bytes));
  return btoa(binaryString);
};

/**
 * Encodes a string to Base64 (Node.js compatible).
 * @param str - The string to encode.
 * @returns The Base64 encoded string.
 * 
 * Test and remove the following code:
 */
export const encodeToBase64Node = (str: string): string => {
  return Buffer.from(str, 'utf-8').toString('base64');
};